var DesktopCarousel = function() {
    var registerNavHandler = function() {
        $('.ii__news_nav').click(function() {
            var index = parseInt($(this).data('index'));
            var currSlide = $('#topnews_carousel').slick('slickCurrentSlide');
            if (!isNaN(index) && index != currSlide) {
                $('.ii__news_nav').off('click');
                $('#topnews_carousel').slick('slickGoTo', index);
                $('.ii__news_nav').removeClass('active');
                $(this).addClass('active');
            }
        });
    };

    return {
        init: function() {
            $('#topnews_carousel').on('init', function() {
                $(this).parent().removeClass('carousel__loading');
                registerNavHandler();
            });

            $('#topnews_carousel').on('afterChange', function() {
                registerNavHandler();
            });

            $('#topnews_carousel').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                lazyLoad: 'ondemand'
            });

            $('.ii__carousel_strip').each(function() {
                var slidesNbr = $(this).data('slides');
                var arrowsClr = $(this).data('arrows');

                $(this).slick({
                    dots: false,
                    infinite: false,
                    slidesToShow: slidesNbr,
                    prevArrow:"<a href='javascript:void(0);' class='slick-arrow slick-arrow--prev btn btn-" + arrowsClr + " btn--square'><i class='fal fa-angle-left'></i></a>",
                    nextArrow:"<a href='javascript:void(0);' class='slick-arrow slick-arrow--next btn btn-" + arrowsClr + " btn--square'><i class='fal fa-angle-right'></i></a>"
                });
            });
        }
    };
}();
